'use client';

import Image from "next/image";
import Link from "next/link";

export default function EzPayPage() {
  return (
    <div className="container">
      <Link href="https://docs.google.com/forms/d/e/1FAIpQLScx-AYVWtUa5yrSJXvNN1wxrTeIg5UxuS1HAIufT5oow4ASSQ/viewform" target="_blank">
        <div className="flex flex-col pt-2">
          <div className="w-full flex justify-center z-10">
            <Image src="/images/banner/ezpay1.png" alt="banner" width={1100} height={450} />
          </div>
          <div className="w-full flex justify-center mt-[-13px] mb-10">
            <Image src="/images/banner/ezpay2.png" alt="banner" width={1100} height={650} />
          </div>
        </div>
      </Link>
    </div>
  );
}
